<template>
  <div
  class="jin-container"
  :class="[$route.meta.type ? `jin-${$route.meta.type}` : '', { 'is-vip-page': vipLivePage }]">
    <div class="jin-box">
      <header-new
        :user="headerUser"
        :show-search="false"
        :show-follow-us="false"
        :mobileShowTabBar="false"
        @login="onUserAction('login')"
        @logout="onUserAction('logout')"
        @register="onUserAction('register')"
      >
        <template slot="navCustom">
          <RoomNav @show-live-tips="onRoomNavLiveTips" />
        </template>
        <template slot="drawerContent">
          <RoomNav @show-live-tips="onRoomNavLiveTips" />
        </template>
      </header-new>
      <!-- <vip-header v-if="isMobile && vipLivePage"></vip-header>
      <c-header ref="header" v-else >
        <prevue-list  slot="prevueList" @update-prevue-show="updatePrevueShow" slot-scope="props" :visible="props.show"></prevue-list>
      </c-header> -->
      <div class="jin-page">
        <div v-if="showContent" class="tv-wrap tv-wrap-main">
          <transition name="fade">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
          </transition>
          <transition name="fade">
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </transition>
        </div>
      </div>
    </div>
    <footer-new></footer-new>
    <!-- <c-side-nav v-if="!vipLivePage && isMobileView"></c-side-nav> -->

    <!-- 密码弹窗 -->
    <div v-if="passwordPopup" class="jin-password-popup">
      <div class="jin-password-popup-content">
        <div class="jin-password-popup-title">请输入密码</div>
        <div class="jin-password-popup-input">
          <input type="password" v-model="password" placeholder="请输入密码">
        </div>
        <div class="jin-password-popup-button">
          <button @click="closePasswordPopup" class="jin-password-popup-button-cancel">取消</button>
          <button @click="checkPassword" class="jin-password-popup-button-confirm">确定</button>
        </div>
      </div>
    </div>
    <BaseOverlay v-model="isOverlayVisible" :z-index="2000">
      <div class="live-tips-content">
        <img class="live-tips-content-img" src="../../assets/img/commons/msgbox/tips@2x.png" alt="live-tips">
        <p>当前节目正在直播，是否继续跳转</p>
        <div class="live-tips-content-footer">
          <glass-btn @click="isOverlayVisible = false" type="default" round size="large">取消</glass-btn>
          <glass-btn @click="handleJump" type="primary" round size="large">跳转</glass-btn>
        </div>
      </div>
    </BaseOverlay>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters, mapState } from 'vuex'
import { device } from '@/commons'
import { addScript, cookie, jin10Behavior } from '../../commons/utils'
import { getConfig } from '@/apis'
import buildTime from '@/buildTime'
import RoomNav from '@/components/HeaderNew/RoomNav.vue'
import BaseOverlay from '@/components/BaseOverlay.vue'

// import HeaderNew from '@/components/HeaderNew'

const privatePageConfig = {
  'gammaPri': 1539,
  'ttps-priv': 1550
}

export default {
  name: 'app',
  components: {
    RoomNav,
    BaseOverlay

    // HeaderNew
  },
  data () {
    return {
      password: '',
      passwordPopup: false,
      showContent: true,
      isOverlayVisible: false,
      jumpItem: null
    }
  },
  computed: {
    ...mapGetters([
      'isLogin',
      'isMobile',
      'liveType',
      'isMobileView'
    ]),
    ...mapState([
      'pageType',
      'user',
      'topNavs',
      'hasGetUser',
      'hasGetDingInfo',
      'hasBuyDing'
    ]),
    vipLivePage () {
      return ['vip', 'tradingNew'].includes(this.pageType)
    },
    headerUser () {
      if (this.user && this.user.fail) {
        return null
      }
      return this.user
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler (to, from) {
        this.$store.dispatch('setPageType', to.meta.type)
        const privatePage = Object.keys(privatePageConfig)
        if (privatePage.includes(to.meta.type)) {
          this.openPasswordPopup()
          this.showContent = false
        } else {
          this.showContent = true
          this.passwordPopup = false
        }
      }
    },
    user: {
      handler (newVal) {
        console.log('user -->', newVal)
      },
      immediate: true
    }
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('checkDevice', device.isMobile)
    // 获取配置数据
    store.dispatch('getOpation').then(() => {
      next()
    })
  },
  created () {
    this.localTimeLoop()
    this.$store.dispatch('getServiceQRCode')
    this.$store.dispatch('setPageType', this.$route.meta.type)
    if (this.jsBridge.isNewApp && !this.vipLivePage) {
      // this.jsBridge.dispatch('goBackApp')
      this.jsBridge.dispatch('openAppTV')
    }

    if (this.jsBridge.isApp) {
      this.jsBridge.getUserInfo(true).then((data) => {
        const token = data.token
        if (token) {
          data = { ...data, t: token }
        }

        cookie.set('x-token', token, null, '/', '.jin10.com', true)

        this.$store.dispatch('setUser', data)
        this.$store.dispatch('setAppUserDataState', true)
      }).catch(() => {
        this.$store.dispatch('setUser', { fail: true })
      })
    } else {
      this.$store.dispatch('getUser', {}).then(() => {
        this.$store.dispatch('setAppUserDataState', true)
      }).catch(() => {})
    }

    window.addEventListener('message', (e) => {
      if (Object.prototype.toString.call(e.data) === '[object Object]') {
        if (e.data.event === 'CHAT_LINK_CLICK') {
          let name = this.user ? this.user.nick : ''
          const nav = this.topNavs.find(it => it.type === (this.liveType || this.pageType))
          const module = nav ? nav.name : '金十智投'
          jin10Behavior({
            pageName: 'tv直播页',
            module,
            action: '点击',
            type: '按钮',
            object: '链接',
            params: {
              name,
              id: e.data.data.id,
              url: e.data.data.url
            }
          })
        } else if (e.data.type === 'UPDATE_ROOM') {
          // 接收UPDATE_ROOM事件数据
          // console.log('接收到UPDATE_ROOM数据:', e.data.data)
          this.handleUpdateRoomData(e.data.data)
        }
      }
    })
  },
  mounted () {
    const time = buildTime ? new Date(buildTime.time) : ''
    console.log('buildTime -->', time)
    if (window.location.href.indexOf('env=test') > -1) {
      addScript('https://cdn.jin10.com/assets/js/eruda.js', () => {
        window.eruda.init()
      })
    }
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    updatePrevueShow (v) {
      this.$refs.header && this.$refs.header.showPrevueList(v)
      this.$refs.header.$refs.navFocus && (this.$refs.header.$refs.navFocus.isShowPrevueList = v)
    },
    localTimeLoop () {
      this.$store.dispatch('setLocalTime')
      setTimeout(() => {
        this.localTimeLoop()
      }, 1000)
    },
    onResize () {
      this.$store.dispatch('setWindowWidth', window.innerWidth)
    },
    handleUpdateRoomData (data) {
      this.$store.dispatch('updateRoomInfo', data)
    },
    closePasswordPopup () {
      this.password = ''
      this.passwordPopup = false
    },
    checkPassword () {
      if (!this.password.trim()) {
        this.$tips('请输入密码')
        return
      }

      const id = privatePageConfig[this.$route.meta.type]
      if (!id) {
        this.$tips('该页面暂不支持密码访问')
        return
      }

      getConfig({ id }).then((res) => {
        const { formData = {} } = res.data.data
        const { pwd = '' } = formData

        if (pwd !== this.password.trim()) {
          this.$tips('密码错误')
          return
        }

        this.showContent = true
        this.passwordPopup = false
      })
    },
    openPasswordPopup () {
      this.password = ''
      this.passwordPopup = true
    },
    onUserAction (action) {
      // if (action !== 'logout') {
      this.$store.dispatch('showLogin', action)
      // } else {
      //   showLoginBox({
      //     type: 'logout'
      //   })
      // }
    },
    onRoomNavLiveTips (item) {
      this.jumpItem = {...item}
      this.isOverlayVisible = true
    },
    handleJump () {
      const item = this.jumpItem
      this.isOverlayVisible = false
      if (item.router) {
        this.$router.push(item.link)
        return false
      }
      window.open(item.link, item.target ? item.target : '_blank')
    }
  }
}
</script>

<style lang="scss">
@import './style/index.scss';

.tv-wrap {
  max-width: 1660px;
  margin: 0 auto;
}

// 确保 header-new 的 z-index 高于其他组件（密码弹窗 2000，侧边导航 1999-2000）
header-new {
  position: relative;
  z-index: 2100 !important;

  // 深度选择器确保样式穿透到组件内部，特别是 fixed 定位的元素
  /deep/ {
    // 对于 fixed 或 absolute 定位的元素，确保 z-index 更高
    [style*="position: fixed"],
    [style*="position:fixed"],
    [style*="position: absolute"],
    [style*="position:absolute"] {
      z-index: 2100 !important;
    }
  }
}

// 确保 tv-video__box 和 jin-side 的 z-index 低于 header-new
// 使用深度选择器确保样式能够穿透到组件内部
// /deep/ .tv-video__box,
// .tv-video__box {
//   z-index: 100 !important;
//   border-radius: 8px;
// }

// /deep/ .jin-side,
// .jin-side {
//   z-index: 200 !important;

//   &.is-fixed,
//   /deep/ .is-fixed {
//     z-index: 200 !important;
//   }
// }

.jin-password-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;

  .jin-password-popup-content {
    width: 300px;
    height: 200px;
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    position: relative;
  }

  .jin-password-popup-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .jin-password-popup-input {
    width: 100%;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 0 10px;
    margin-bottom: 30px;

    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      font-size: 16px;
    }
  }

  .jin-password-popup-button {
    display: flex;
    justify-content: space-between;

    button {
      width: 120px;
      height: 40px;
      border: none;
      border-radius: 5px;
      color: #fff;
      cursor: pointer;
    }

    .jin-password-popup-button-confirm {
      background-color: #5c8eea;
    }

    .jin-password-popup-button-cancel {
      color: #000;
    }
  }
}
.live-tips-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  &-img {
    margin-bottom: 12px;
    height: 69px;
  }
  p {
    margin-bottom: 28px;
    font-size: 14px;
    font-weight: bold;
    color: var(--on-card);
    line-height: normal;
  }
  &-footer {
    width: 100%;
    display: flex;
    gap: 12px;
    button {
      flex: 1;
      height: 45px;
    }
  }
}


</style>



// WEBPACK FOOTER //
// App.vue?1f1656a0